module.exports = __webpack_public_path__ + "static/media/Hombre5.87e4dec2.svg";